(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/views/reduce-handle.js') >= 0) return;  svs.modules.push('/modules/tipset/views/reduce-handle.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tipset=_svs.tipset||{};
_svs.tipset.templates=_svs.tipset.templates||{};
svs.tipset.templates.reduce_handle = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " hide-reduce-handle";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"reduce-handle-container handle-"
    + container.escapeExpression(((helper = (helper = helpers.orientation || (depth0 != null ? depth0.orientation : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(alias1,{"name":"orientation","hash":{},"data":data}) : helper)))
    + " "
    + ((stack1 = helpers.unless.call(alias1,(depth0 != null ? depth0.show : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n    <div class=\"reduce-handle\">\n        <i class=\"icon icon-default icon-caret-left\"></i>\n        <i class=\"icon icon-default icon-caret-right\"></i>\n    </div>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-tipset-reduce_handle'] = svs.tipset.templates.reduce_handle;
})(svs, Handlebars);

 })(window);